import { IPost } from "api/types/_news";
import {
  CONFIG_OPTION_TOAST_ERROR,
  CONFIG_OPTION_TOAST_INFO,
  CONFIG_OPTION_TOAST_NORMAL,
} from "common/toast";
import BreadCrumb from "components/Common/BreadCrumb";
import DatePickerCustom from "components/Common/DatePickerCustom";
import DropdownStatus from "components/Common/DropdownStatus";
import LabelWrapper from "components/Common/LabelWrapper";
import ModalConfirm from "components/Common/ModalConfirm";
import NewsTableContainer from "components/Common/NewsTableContainer";
import { useRole } from "components/Hooks/UserHooks";
import FeatherIcon from "feather-icons-react";
import {
  COLORS_STATUS_POST,
  ENUM_STATUS_POST,
  STATUS_POST_OPTIONS,
  WEBSITE_POST_OPTIONS
} from "helpers/constans";
import { ROLES_FOR_APP, isHavePermissionRole } from "helpers/role";
import moment from 'moment-timezone';
import React, {
  useCallback,
  useEffect,
  useMemo,
  useRef,
  useState,
} from "react";
import CountUp from "react-countup";
import { useTranslation } from "react-i18next";
import { Link, useNavigate } from "react-router-dom";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import {
  Card,
  CardBody,
  CardHeader,
  Col,
  Container,
  Input,
  Modal,
  ModalBody,
  ModalFooter,
  ModalHeader,
  Row,
  Spinner,
} from "reactstrap";
import {
  actionPost,
  getNews,
  getPostByNormal
} from "store/thunks";
import {
  NumberParam,
  StringParam,
  useQueryParams,
  withDefault,
} from "use-query-params";
import CopyPreventionComponent from "../Components/CopyPreventionComponent";
import CopyTextToClipboard from "../Components/CopyTextToClipboard";
import HighlightText from "../Components/HighlightText";
import NestingFilter from "../Components/NestingFilter";
import SpinnerScreen from "../Components/SpinnerScreen";
import TooltipCustom from "components/Common/TooltipCustom";
import DropdownOption from "components/Common/DropdownOption";
import { formatLinkHTTPS } from "helpers/format";
import ModalPostArticle from "./ModalPostArticle";
import CopyWrapper from "components/Common/CopyWrapper";

interface Option {
  label: string;
  value: string;
}

export interface Tag {
  id: string;
  text: string;
}

const TYPE_SELECT_DEFAULT: string = "created_at";

const PostList = () => {
  let document_w: any = window.document;
  const { t, i18n } = useTranslation();
  const { userPermissions } = useRole();
  const navigate = useNavigate();

  const modalRef = useRef<any>(null);

  const modalBodyInnerRef = useRef<any>(null);

  const isModalFullScreenRef = useRef<number>(0);

  const isFirstLoadingPageRef = useRef<any>(true);

  const STATUS_POST_OPTIONS_LANG = STATUS_POST_OPTIONS?.map((item: any) => ({
    value: item?.value,
    label: t(item?.label),
  }));

  const WEBSITE_POST_OPTIONS_LANG = WEBSITE_POST_OPTIONS?.map((item: any) => ({
    value: item?.value,
    label: t(item?.label),
  }));


  const START_DATE = `${moment().subtract(7, "days").format("Y-MM-DD")}`;
  const END_DATE = `${moment().format("Y-MM-DD")}`;

  const [query, setQuery]: any = useQueryParams({
    time_request: withDefault(NumberParam, 0),
    page: withDefault(NumberParam, 1),
    limit: withDefault(NumberParam, 100),
    sort_by: withDefault(StringParam, TYPE_SELECT_DEFAULT),
    order_by: withDefault(StringParam, "DESC"),
    from_created_at: withDefault(StringParam, ''),
    to_created_at: withDefault(StringParam, ''),
    category: withDefault(StringParam, ""),
    website: withDefault(StringParam, WEBSITE_POST_OPTIONS_LANG[0]?.value),
    title: withDefault(StringParam, ""),
    status: withDefault(StringParam, ""),
    type_page_no_param: withDefault(StringParam, ""),
  });

  const [categorySearch, setCategorySearch] = useState<string>(
    query?.category || ""
  );

  const [titleSearch, setTitleSearch] = useState<string>(query?.title || "");

  const [statusSearch, setStatusSearch] = useState<Option | null>(
    STATUS_POST_OPTIONS_LANG?.find(
      (item) => String(item?.value) === String(query?.status)
    ) || null
  );

  const [websiteSearch, setWebsiteSearch] = useState<Option | null>(
    WEBSITE_POST_OPTIONS_LANG?.find(
      (item) => String(item?.value) === String(query?.status)
    ) || null
  );

  const [dateSearch, setDateSearch] = useState<any[]>([
    query?.from_created_at ? moment(query?.from_created_at, "Y-MM-DD").toDate() : null,
    query?.to_created_at ? moment(query?.to_created_at, "Y-MM-DD").toDate() : null,
  ]);
  const [startDate, endDate] = dateSearch;

  const [newsDetail, setNewsDetail] = useState<IPost | null>(null);

  const [typeShowList, setTypeShowList] = useState<"CARD" | "TABLE">("TABLE");

  const [isOpenConfirm, setIsOpenConfirm] = useState<boolean>(false);
  const [isConfirmLoading, setIsConfirmLoading] = useState<boolean>(false);
  const [typeActionConfirm, setTypeActionConfirm] = useState<{ id: string | number; type: "RUN" | "CANCEL" } | null>(null);

  const [isOpenPostArticle, setIsOpenPostArticle] = useState<boolean>(false);

  const [listNews, setListNews] = useState<{ list: IPost[]; total: number }>({
    list: [],
    total: 0,
  });
  const [isListNewsLoading, setIsListNewsLoading] = useState<boolean>(false);

  const handleQueryData = async () => {
    setIsListNewsLoading((prev) => true);
    if (isFirstLoadingPageRef?.current === true) {
      isFirstLoadingPageRef.current = false;
      setQuery({
        ...query,
        type_page_no_param: "",
        to_created_at: endDate ? moment(new Date(endDate)).format("Y-MM-DD") : "",
        page: 1,
      });
      return;
    }
    isFirstLoadingPageRef.current = false;
    const res: any = await getPostByNormal(query);
    setListNews((prev: any) => ({
      list: res?.data?.list || [],
      total: res?.data?.pagination?.total || 0,
    }));
    setIsListNewsLoading((prev) => false);

    if (!!newsDetail && query?.type_page_no_param) {
      if (query?.type_page_no_param === "prev") {
        setNewsDetail((_prev) => res?.data?.list[res?.data?.list?.length - 1]);
        return;
      }
      if (query?.type_page_no_param === "next") {
        setNewsDetail((_prev) => res?.data?.list[0]);
        return;
      }
    }
  };

  const handleLoadMore = () => {
    setQuery({
      ...query,
      page: query?.page + 1,
      type_page_no_param: "next",
    });
  };

  const handleLoadPrev = () => {
    setQuery({
      ...query,
      page: query?.page - 1,
      type_page_no_param: "prev",
    });
  };

  useEffect(() => {
    handleQueryData();
  }, [JSON.stringify(query), isFirstLoadingPageRef?.current]);

  const searchData = () => {
    const queryNew = {
      ...query,
      from_created_at: startDate
        ? moment(new Date(startDate)).format("Y-MM-DD")
        : "",
      to_created_at: endDate ? moment(new Date(endDate)).format("Y-MM-DD") : "",
      category: categorySearch || "",
      website: websiteSearch?.value,
      title: titleSearch || "",
      status: statusSearch?.value,
      page: 1,
      time_request: +new Date(),
    };
    if (JSON.stringify(query) !== JSON.stringify(queryNew)) {
      setListNews((prev: any) => ({
        list: [],
        total: 0,
      }));
    }
    setQuery(queryNew);
  };

  const resetData = () => {
    const queryNew = {
      title: "",
      category: "",
      website: WEBSITE_POST_OPTIONS_LANG[0]?.value,
      status: "",
      from_created_at: '',
      to_created_at: '',
      sort_by: TYPE_SELECT_DEFAULT,
      order_by: "DESC",
      page: 1,
      time_request: +new Date(),
    };
    if (JSON.stringify(query) !== JSON.stringify(queryNew)) {
      setListNews((prev: any) => ({
        list: [],
        total: 0,
      }));
    }
    setQuery(queryNew, "push");
    setTitleSearch((_prev) => "");
    setCategorySearch((_prev) => "");
    setWebsiteSearch(WEBSITE_POST_OPTIONS_LANG[0]);
    setStatusSearch(null);
    setDateSearch([
      null,
      null,
    ]);
  };

  const handleGetDetailNews = async (id_news: string | number) => {
    try {
      getNews(id_news);
    } catch (error) {
      //
    }
  };

  const handleSetNewsDetail = (detail: IPost | null) => {
    setNewsDetail((_prev) => detail);
    if (!!detail) {
      handleGetDetailNews(detail?.id);
    }
    if (window?.innerWidth <= 900) {
      setTimeout(async () => {
        try {
          if (!!detail) {
            if (
              isModalFullScreenRef.current <= 0 &&
              !(
                !document_w.fullscreenElement &&
                !document_w.mozFullScreenElement &&
                !document_w.webkitFullscreenElement
              )
            ) {
              isModalFullScreenRef.current = 0;
            } else if (
              !document_w.fullscreenElement &&
              !document_w.mozFullScreenElement &&
              !document_w.webkitFullscreenElement
            ) {
              isModalFullScreenRef.current = 1;
              if (document_w.documentElement.requestFullscreen) {
                document_w.documentElement.requestFullscreen();
              } else if (document_w.documentElement.mozRequestFullScreen) {
                document_w.documentElement.mozRequestFullScreen();
              } else if (document_w.documentElement.webkitRequestFullscreen) {
                document_w.documentElement.webkitRequestFullscreen();
              }
            }
          }
        } catch (error) {
          //console.error("Failed to enter fullscreen:", error);
        }
      }, 280);
    }
  };

  const onCloseClick = () => {
    handleSetNewsDetail(null);
    if (window?.innerWidth <= 900) {
      setTimeout(async () => {
        try {
          if (isModalFullScreenRef?.current > 0) {
            isModalFullScreenRef.current = 0;
            if (document_w.cancelFullScreen) {
              document_w.cancelFullScreen();
            } else if (document_w.mozCancelFullScreen) {
              document_w.mozCancelFullScreen();
            } else if (document_w.webkitCancelFullScreen) {
              document_w.webkitCancelFullScreen();
            }
          }
        } catch (error) {
          //console.error("Failed to enter fullscreen:", error);
        }
      }, 280);
    }
  };

  const scrollModalBodyToTop = () => {
    if (modalBodyInnerRef.current) {
      modalBodyInnerRef.current.scrollTo({
        top: 0,
      });
    }
  };

  const handlePreviousNews = (index_news_current: number = 0) => {
    if (listNews?.list?.length) {
      const indexNewsPrevious = Number(index_news_current) - 1;
      const newsPrevious = listNews?.list[indexNewsPrevious];
      if (!!newsPrevious) {
        handleSetNewsDetail({
          ...newsPrevious,
          index: indexNewsPrevious,
          disabled_prev: false,
          disabled_next: false,
        });
        scrollModalBodyToTop();
      }
      if (!newsPrevious) {
        if (Number(query?.page) > 1) {
          handleLoadPrev();
        } else {
          toast(
            t("There is no news article anymore!"),
            CONFIG_OPTION_TOAST_INFO
          );
        }
      }
    }
  };

  const handleNextNews = (index_news_current: number = 0) => {
    if (listNews?.list?.length) {
      const indexNewsNext = Number(index_news_current) + 1;
      const newsNext = listNews?.list[indexNewsNext];
      if (!!newsNext) {
        handleSetNewsDetail({
          ...newsNext,
          index: indexNewsNext,
          disabled_prev: false,
          disabled_next: false,
        });
        scrollModalBodyToTop();
      }
      if (!newsNext) {
        if (
          Number(query?.page) <
          Math.ceil(Number(listNews?.total) / Number(query?.limit || 300))
        ) {
          handleLoadMore();
        } else {
          toast(
            t("There is no news article anymore!"),
            CONFIG_OPTION_TOAST_INFO
          );
        }
      }
    }
  };

  const onClickOpenPostArticle = () => {
    setIsOpenPostArticle(true);
  };

  const onClickClosePostArticle = () => {
    setIsOpenPostArticle(false);
  };

  const handleReloadListNews = () => {
    resetData();
    setIsOpenPostArticle(false);
  }

  // Column
  const columns = useMemo(
    () => [
      {
        Header: t("ID"),
        accessor: "id",
        filterable: true,
        sortable: false,
        thWidth: 90,
        Cell: (cell: any) => (
          <>
            <div style={{ minWidth: "60px" }}>{cell?.value}</div>
          </>
        ),
      },
      {
        Header: t("Status"),
        accessor: "status",
        filterable: false,
        sortable: false,
        thClass: "align-middle text-start",
        thWidth: 95,
        Cell: (cell: any) => {
          const item: any = cell?.row?.original;
          return (
            <div style={{ minWidth: "60px" }} className="text-start fs-16">
              <span
                className={`rounded-pill badge bg-${COLORS_STATUS_POST[`${cell?.value || 0}`] || "success"
                  }`}
              >
                {STATUS_POST_OPTIONS_LANG?.find(
                  (s) => String(s?.value) === String(item?.status)
                )?.label || ""}
              </span>
            </div>
          );
        },
      },
      {
        Header: t("Website"),
        accessor: "website",
        filterable: true,
        sortable: false,
        thWidth: i18n?.language === 'en' ? 130 : 160,
        Cell: (cell: any) => {
          const item = cell?.row?.original;
          return (
            <>
              <div style={{ minWidth: i18n?.language === 'en' ? "130px" : "150px" }}>
                {WEBSITE_POST_OPTIONS_LANG?.find((_w: any) => _w?.value === cell?.value)?.label || '-'}
              </div>
            </>
          );
        },
      },
      {
        Header: t("Category"),
        accessor: "category_id",
        filterable: true,
        sortable: false,
        thWidth: 130,
        thClass: "align-middle text-start",
        Cell: (cell: any) => {
          const item = cell?.row?.original;
          return (
            <div
              style={{ minWidth: "70px" }}
              className="text-start"
            >
              {item?.category_id || ""}
            </div>
          );
        },
      },
      {
        Header: t("Title"),
        accessor: "title",
        filterable: true,
        sortable: false,
        // thWidth: 240,
        thClass: "align-middle",
        thWidth: !listNews?.list?.length ? 100 : window.innerWidth < 1650 ? 350 : 600,
        Cell: (cell: any) => {
          const item = cell?.row?.original;
          return (
            <>
              <div className="d-flex" style={{ minWidth: "300px", maxWidth: "600px" }}>
                {[ENUM_STATUS_POST.SUCCESS].includes(Number(item?.status)) && <div className="d-flex me-1">
                  <span className="text-primary">[</span>
                  <Link className='text-normal flex-shrink-0 hover-underline' to={formatLinkHTTPS(item?.url)} target="_blank">
                    {t('Link')}
                  </Link>
                  <span className="text-primary">]</span>
                </div>}
                <div
                  className={`fs-15 cursor-pointer hover-underline`}
                  onClick={(e) => {
                    e.preventDefault();
                    handleSetNewsDetail({ ...item, index: cell?.row?.index });
                  }}
                >
                  {cell?.value || ""}
                </div>
              </div>

            </>
          );
        },
      },
      {
        Header: t("Error"),
        accessor: "error_message",
        filterable: true,
        sortable: false,
        thWidth: 170,
        thClass: "align-middle text-start",
        Cell: (cell: any) => {
          const item = cell?.row?.original;
          return (
            <>
              <div style={{ minWidth: "80px", maxWidth: "160px" }} className=" text-start">
                <TooltipCustom
                  title={cell?.value || "-"}
                  className="d-inline-block vertical-align-middle ms-1"
                >
                  <div className="text-danger limit-text-to-two-line">
                    {cell?.value || "-"}
                  </div>
                </TooltipCustom>
              </div>
            </>
          );
        },
      },
      {
        Header: t("Retry Count"),
        accessor: "retry",
        filterable: true,
        sortable: false,
        thWidth: 100,
        thClass: "align-middle text-center",
        Cell: (cell: any) => {
          const item = cell?.row?.original;
          return (
            <>
              <div style={{ minWidth: "80px" }} className="fs-15 text-center">
                {cell?.value || "0"}
              </div>
            </>
          );
        },
      },
      {
        Header: t("Author"),
        accessor: "author",
        filterable: true,
        sortable: false,
        thWidth: 180,
        thClass: "align-middle text-start",
        Cell: (cell: any) => {
          const item = cell?.row?.original;
          return (
            <>
              <div style={{ minWidth: "180px" }} className="text-start fs-14">
                <div><span className="fs-12 text-muted me-1">{t('Author')}:</span>{item?.author || ""}</div>
                <div className="d-flex align-items-baseline"><span className="fs-12 text-muted me-1">{t('Pass')}: </span>
                  <CopyWrapper contentCopy={item?.password}>
                    {item?.password || ""}
                  </CopyWrapper>
                </div>
              </div>
            </>
          );
        },
      },
      {
        Header: t("Created At"),
        accessor: "created_at",
        filterable: true,
        sortable: true,
        thWidth: 120,
        thClass: "align-middle text-end",
        Cell: (cell: any) => {
          const arrDate = String(cell?.value || "").split(" ");
          return (
            <div className="text-end pe-3" style={{ minWidth: '100px' }}>
              <span><span>{arrDate?.[0] || '-'}</span> <br /> <span className="text-secondary">{arrDate?.[1] || '-'}</span> </span>
            </div>
          );
        },
      },
      {
        Header: t("Updated At"),
        accessor: "updated_at",
        filterable: true,
        sortable: true,
        thWidth: 120,
        thClass: "align-middle text-end",
        Cell: (cell: any) => {
          const arrDate = String(cell?.value || "").split(" ");
          return (
            <div className="text-end pe-3" style={{ minWidth: '100px' }}>
              <span><span>{arrDate?.[0] || '-'}</span> <br /> <span className="text-secondary">{arrDate?.[1] || '-'}</span> </span>
            </div>
          );
        },
      },
      {
        Header: t("Action"),
        accessor: "__",
        thClass: "align-middle text-center",
        thWidth: 100,
        sortable: false,
        Cell: (cell: any) => {
          const item: any = cell?.row?.original;
          return (
            <ul
              className="list-inline flex-wrap justify-content-center hstack gap-2 mb-0"
              style={{ minWidth: "90px" }}
            >
              {[ENUM_STATUS_POST.FAIL, ENUM_STATUS_POST.CANCEL].includes(item?.status) && <li
                className=" list-inline-item me-0"
                id={`detail-us-${item?.id}`}
              >
                <button
                  className={`btn btn-sm btn-success edit-item-btn`}
                  onClick={(e) => {
                    e.preventDefault();
                    onOpenConfirmClick(item?.id, "RUN");
                  }}
                  disabled={isConfirmLoading}
                  style={{ width: '68px' }}
                >
                  {/* <i
                    className="ri ri-play-line"
                    style={{ verticalAlign: "text-top", marginRight: "2px" }}
                  /> */}
                  {t("Button Run")}
                </button>
              </li>}
              {[ENUM_STATUS_POST.INIT, ENUM_STATUS_POST.IN_PROGRESS, ENUM_STATUS_POST.SUCCESS].includes(item?.status) && <li
                className=" list-inline-item me-0"
                id={`detail-us-${item?.id}`}
              >
                <button
                  className={`btn btn-sm btn-danger edit-item-btn`}
                  onClick={(e) => {
                    e.preventDefault();
                    onOpenConfirmClick(item?.id, "CANCEL");
                  }}
                  disabled={isConfirmLoading || !(item?.status === ENUM_STATUS_POST.INIT)}
                  style={{ width: '68px' }}
                >
                  {/* <i
                    className="ri-compass-4-line me-1"
                    style={{ verticalAlign: "text-top", marginRight: "2px" }}
                  /> */}
                  {t("Button Cancel")}
                </button>
              </li>}
            </ul >
          );
        },
      },
    ],
    [i18n?.language, listNews?.list?.length, query, userPermissions]
  );

  const handleChangePage = useCallback((page: any) => {
    setQuery({ page: page + 1 });
  }, []);

  const handleChangeSorting = useCallback((sortBy: any) => {
    setListNews((prev: any) => ({
      list: [],
      total: 0,
    }));
    setQuery((_prev: any) => {
      return { ..._prev, ...sortBy, page: 1 };
    });
  }, []);

  const onOpenConfirmClick = async (id: string | number, type: "RUN" | "CANCEL") => {
    setTypeActionConfirm((_prev) => ({ id, type }));
    setIsOpenConfirm(true);
  };

  const onCloseConfirmClick = () => {
    setTypeActionConfirm((_prev) => null);
    setIsOpenConfirm(false);
  };

  const handleActionConfirm = async () => {
    try {
      if (!typeActionConfirm?.id) {
        return;
      }
      setIsConfirmLoading((_prev) => true);
      const response: any = await actionPost(typeActionConfirm?.id, {
        type: typeActionConfirm?.type,
      });
      setIsConfirmLoading((_prev) => false);
      if (response?.code === 200) {
        setIsOpenConfirm(false);
        const now = moment.tz("Asia/Seoul");
        const updated_at = now.format('YYYY-MM-DD HH:mm:ss');
        setListNews((_prev) => (
          {
            list: _prev?.list?.map((item) => (item?.id === typeActionConfirm?.id ? {
              ...item,
              status: typeActionConfirm?.type === "CANCEL" ? ENUM_STATUS_POST.CANCEL : ENUM_STATUS_POST.INIT,
              updated_at: updated_at
            } : item)),
            total: _prev?.total,
          }
        ));
        if (!!newsDetail?.id) {
          setNewsDetail(
            (_prev) => ({
              ..._prev,
              status: typeActionConfirm?.type === "CANCEL" ? ENUM_STATUS_POST.CANCEL : ENUM_STATUS_POST.INIT,
              updated_at: updated_at
            } as IPost)
          );
        }
        toast(`${t('The process has been completed.')}`, CONFIG_OPTION_TOAST_NORMAL);
      } else {
        toast(`${response}`, CONFIG_OPTION_TOAST_ERROR);
      }
    } catch (error: any) {
      setIsConfirmLoading((_prev) => false);
      toast(`${error?.message || ""}`, CONFIG_OPTION_TOAST_ERROR);
      return error;
    }
  };

  const handleChangePicker = (values: any[] = []) => {
    setDateSearch((_prev: any) => values);
  };

  useEffect(() => {
    document.title = `${t("Posts")} | ${t("PRESS Ai")}`;
    document.body.classList.remove("vertical-sidebar-enable");
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [i18n?.language]);

  // const [isS, setIsS] = useState<boolean>(true);
  // useEffect(() => {
  //   setTimeout(async () => {
  //     try {
  //       setIsS((_prev) => false);
  //     } catch (error) {
  //       //console.error("Failed to enter fullscreen:", error);
  //     }
  //   }, 2000);
  //   // eslint-disable-next-line react-hooks/exhaustive-deps
  // }, []);

  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid>
          <BreadCrumb title={t("Posts")} pageTitle={t("Home")} />
          <Row className="h-auto-custom">
            {isHavePermissionRole(ROLES_FOR_APP.POSTS, userPermissions) && (
              <Col lg={12}>
                {/* <SpinnerScreen isShow={isS} className="duration-4" /> */}
                <Card
                  id="customerList"
                  style={{ boxShadow: "0px 3px 4px 0px rgba(0, 0, 0, 0.03)" }}
                >
                  <CardHeader className="border-0">
                    <Row className="g-4 align-items-center">
                      <div className="col-6">
                        <div>
                          <h5 className="card-title mb-0">
                            <span className="me-2">{t("Total")}:</span>
                            {isListNewsLoading && query?.page === 1 ? (
                              <Spinner
                                size="sm"
                                className="text-primary"
                              ></Spinner>
                            ) : (
                              <CountUp
                                start={0}
                                end={listNews?.total || 0}
                                duration={1}
                                className="text-primary"
                              />
                            )}
                          </h5>
                        </div>
                      </div>
                      <div className="col-6 text-end">
                        <button
                          type="button"
                          className="btn btn-success me-3"
                          onClick={() => setIsOpenPostArticle(true)}
                          disabled={isListNewsLoading}
                        >
                          {t("Button Create Post")}
                        </button>
                        <button
                          type="button"
                          className="btn btn-info py-1 px-2"
                          onClick={() =>
                            setTypeShowList((_prev) =>
                              _prev === "CARD" ? "TABLE" : "CARD"
                            )
                          }
                        >
                          {typeShowList === "TABLE" ? (
                            <i className="ri-list-check-2 align-center fs-20" />
                          ) : (
                            <i className="ri-table-2 align-center fs-20" />
                          )}
                        </button>
                      </div>
                    </Row>
                  </CardHeader>
                  <div className=" border border-dashed border-end-0 border-start-0 card-body mt-0 pb-4 px-0 px-lg-3 pt-0 pt-lg-3">
                    <NestingFilter>
                      <Row className="g-4 align-items-end mt-0">
                        <Col
                          sm={6}
                          md={6}
                          lg={6}
                          xl={4}
                          xxl={2}
                          className="mt-3 mt-xxl-2"
                        >
                          <LabelWrapper label={t("Status")} isShow={true}>
                            <DropdownStatus
                              name="status"
                              dataList={STATUS_POST_OPTIONS_LANG || []}
                              placeholder={`${t("Status")}...`}
                              className="dropdown-status-rounded z-hight"
                              classNamePrefix="name-prefix"
                              initialValue={statusSearch || null}
                              onChangeSelect={(e: any) => setStatusSearch(e)}
                              isHasOptionAll={true}
                              optionAll={{ label: t("All"), value: "" }}
                              colors={COLORS_STATUS_POST}
                            />
                          </LabelWrapper>
                        </Col>

                        <Col
                          sm={6}
                          md={6}
                          lg={6}
                          xl={4}
                          xxl={2}
                          className="mt-3 mt-xxl-2"
                        >
                          <LabelWrapper
                            label={t("Website")}
                            isShow={!!websiteSearch}
                          >
                            <DropdownOption
                              name="website"
                              dataList={WEBSITE_POST_OPTIONS_LANG || []}
                              placeholder={`${t("Website")}...`}
                              className="dropdown-status-rounded z-hight"
                              classNamePrefix="name-prefix"
                              initialValue={websiteSearch || null}
                              onChangeSelect={(e: any) => setWebsiteSearch(e)}
                              isHasOptionAll={true}
                              optionAll={{ label: t("All"), value: "" }}
                            />
                          </LabelWrapper>
                        </Col>
                        <Col
                          sm={6}
                          md={6}
                          lg={6}
                          xl={4}
                          xxl={2}
                          className="mt-3 mt-xxl-2"
                        >
                          <LabelWrapper
                            label={t("Category")}
                            isShow={!!categorySearch}
                          >
                            <Input
                              type="text"
                              className="form-control search"
                              placeholder={`${t("Category")}...`}
                              value={categorySearch}
                              onChange={(e) => setCategorySearch(e.target.value)}
                              onKeyDown={(e) => {
                                if (e.key === "Enter") {
                                  searchData();
                                }
                              }}
                            />
                          </LabelWrapper>
                        </Col>
                        <Col
                          sm={6}
                          md={6}
                          lg={6}
                          xl={4}
                          xxl={3}
                          className="mt-3 mt-xxl-2"
                        >
                          <LabelWrapper
                            label={t("Title")}
                            isShow={!!titleSearch}
                          >
                            <Input
                              type="text"
                              className="form-control search"
                              placeholder={`${t("Title")}...`}
                              value={titleSearch}
                              onChange={(e) => setTitleSearch(e.target.value)}
                              onKeyDown={(e) => {
                                if (e.key === "Enter") {
                                  searchData();
                                }
                              }}
                            />
                          </LabelWrapper>
                        </Col>

                        <Col
                          sm={6}
                          md={6}
                          lg={6}
                          xl={4}
                          xxl={3}
                          className="date-picker-wrapper-custom mt-3 mt-xxl-2"
                        >
                          <LabelWrapper
                            label={t("Date")}
                            isShow={!!startDate || !!endDate}
                          >
                            <DatePickerCustom
                              placeholder={`${t("Start Date")} - ${t(
                                "End Date"
                              )}`}
                              startDate={startDate || null}
                              endDate={endDate || null}
                              onChangePicker={handleChangePicker}
                              showOptions={[
                                "today",
                                "yesterday",
                                "two_day_ago",
                                "last_3_days",
                                "last_7_days",
                                "last_14_days",
                                "last_30_days",
                                "this_week",
                                "last_week",
                                "this_month",
                                "last_month",
                              ]}
                            />
                          </LabelWrapper>
                        </Col>
                        <Col
                          sm={6}
                          md={6}
                          lg={6}
                          xl={4}
                          xxl={12}
                          className="hstack gap-1 justify-content-center justify-content-sm-end justify-content-lg-end justify-content-xl-start justify-content-xxl-end mt-3 mt-xxl-3"
                        >
                          <div>
                            <button
                              type="button"
                              className="btn btn-primary me-2 me-lg-2"
                              onClick={searchData}
                              disabled={isListNewsLoading}
                            >
                              <i className="ri-search-line align-bottom me-1"></i>{" "}
                              {t("Button Search")}
                            </button>
                            <button
                              type="button"
                              className="btn btn-secondary fs-14"
                              onClick={resetData}
                            >
                              <i className="ri-refresh-line align-bottom me-1"></i>{" "}
                              {t("Button Reset")}
                            </button>
                          </div>
                        </Col>
                      </Row>
                    </NestingFilter>
                  </div>
                  <CardBody className="pt-0 px-0">
                    <div className="mx-3 my-4 mt-3">
                      <NewsTableContainer
                        className="custom-header-css"
                        divClass="table-responsive table-card"
                        tableClass="align-middle sticky-table-posts"
                        theadClass="table-light"
                        columns={columns}
                        data={listNews?.list?.length ? listNews?.list : []}
                        customPageSize={query.limit}
                        customPageIndex={query.page - 1}
                        totalRecords={listNews?.total}
                        customPageCount={Math.ceil(
                          Number(listNews?.total) /
                          Number(query?.limit || 300)
                        )}
                        handleChangePage={handleChangePage}
                        manualSorting={true}
                        sorting={{
                          sort_by: query.sort_by,
                          order_by: query.order_by,
                        }}
                        handleChangeSorting={handleChangeSorting}
                        isLoading={isListNewsLoading}
                        typeShowList={typeShowList}
                        handleClickDetailCard={handleSetNewsDetail}
                        isShowPagination={true}
                        isShowLoadingBottom={false}
                        isScrollToTop={true}
                      />
                    </div>
                  </CardBody>
                </Card>
              </Col>
            )}
          </Row>
        </Container>
        <ToastContainer
          closeButton={false}
          newestOnTop={false}
          pauseOnFocusLoss
          autoClose={2000}
          limit={2}
        />
        <Modal
          isOpen={!!newsDetail}
          centered={window?.innerWidth > 900 ? true : false}
          size="xl"
          className={`border-header-footer ${window?.innerWidth > 900 ? "" : "modal-fullscreen "
            }`}
          scrollable={window?.innerWidth > 900 ? true : false}
          toggle={onCloseClick}
          keyboard={true}
          innerRef={modalRef}
        >
          <ModalHeader toggle={onCloseClick}>
            <div className="d-flex flex-column flex-sm-row gap-0 gap-sm-2 fs-18 fs-md-20">
              <div className="flex-grow-1">
                {t("Posts")}
                <span
                  className={`mx-2 rounded-pill badge bg-${COLORS_STATUS_POST[`${newsDetail?.status || 0}`] ||
                    "success"
                    }`}
                >
                  {STATUS_POST_OPTIONS_LANG?.find(
                    (s) => String(s?.value) === String(newsDetail?.status)
                  )?.label || ""}
                </span>
                <span
                  key={newsDetail?.category_id}
                  className={`rounded-pill me-2 badge bg-success-subtle text-success`}
                >
                  {
                    newsDetail?.category_id || ''
                  }
                </span>
              </div>
            </div>
          </ModalHeader>
          <ModalBody className="position-relative">
            <div
              ref={modalBodyInnerRef}
              className="inner-modal-body color-scrollbar-os"
            >
              <CopyPreventionComponent isCopy={!!newsDetail?.is_can_copy}>
                <div className="pb-3">
                  <p
                    className="mb-3 fs-22 fs-md-23"
                    style={{ lineHeight: "170%", fontWeight: 600 }}
                  >
                    <CopyTextToClipboard
                      text={newsDetail?.title || ""}
                      isCopy={!!newsDetail?.is_can_copy}
                    >
                      <HighlightText
                        text={newsDetail?.title || ""}
                        keyword={newsDetail?.keyword || ""}
                      />
                    </CopyTextToClipboard>
                  </p>
                  <p
                    className="mb-3 mt-3 fs-17 fs-md-18"
                    style={{ whiteSpace: "pre-line", lineHeight: "170%" }}
                  >
                    <CopyTextToClipboard
                      text={newsDetail?.content || ""}
                      isCopy={!!newsDetail?.is_can_copy}
                    >
                      <div dangerouslySetInnerHTML={{ __html: `${newsDetail?.content}` }} />
                    </CopyTextToClipboard>
                  </p>
                </div>
              </CopyPreventionComponent>
            </div>
          </ModalBody>
          <ModalFooter
            className="position-relative footer-button-new"
            lang={i18n?.language || "en"}
          >
            <div className="w-100 d-flex gap-2 justify-content-between align-items-center flex-wrap ">
              <strong>
                <div className="d-flex align-items-center">

                  {[ENUM_STATUS_POST.FAIL, ENUM_STATUS_POST.CANCEL].includes(Number(newsDetail?.status)) && <button
                    className="btn btn-success fs-14 px-1 d-flex justify-content-center align-item-center"
                    type="button"
                    color="light"
                    onClick={() => onOpenConfirmClick(newsDetail?.id || '', "RUN")}
                    disabled={isConfirmLoading}
                    style={{ width: "90px" }}
                  >
                    <i
                      className="ri ri-play-line"
                      style={{ lineHeight: "22px" }}
                    />
                    <span className="ms-1">{t("Button Run")}</span>
                  </button>
                  }
                  {[ENUM_STATUS_POST.INIT].includes(Number(newsDetail?.status)) && <button
                    className="btn btn-danger fs-14 px-1 d-flex justify-content-center align-item-center"
                    type="button"
                    color="light"
                    onClick={() => onOpenConfirmClick(newsDetail?.id || '', "CANCEL")}
                    disabled={isConfirmLoading}
                    style={{ width: "90px" }}
                  >
                    <i
                      className="ri ri-compass-4-line"
                      style={{ lineHeight: "22px" }}
                    />
                    <span className="ms-1">{t("Button Cancel")}</span>
                  </button>
                  }
                </div>
              </strong>
              <div className="d-flex flex-grow-1 gap-2 gap-sm-3 justify-content-end justify-content-sm-end mt-2 mt-sm-0 flex-wrap-sm-300">
                <div className="btn-group btn-width-next-news">
                  <button
                    type="button"
                    title={t("Previous News")}
                    style={{ height: "40px" }}
                    aria-pressed="false"
                    className="btn fs-14 btn-secondary d-flex justify-content-center align-item-center"
                    disabled={
                      isListNewsLoading ||
                      isConfirmLoading ||
                      !!newsDetail?.disabled_prev
                    }
                    onClick={() => handlePreviousNews(newsDetail?.index)}
                  >
                    {isListNewsLoading &&
                      query?.type_page_no_param === "prev" ? (
                      <span
                        style={{ transform: "translateY(3px)", width: "18px" }}
                      >
                        <Spinner size="sm"></Spinner>
                      </span>
                    ) : (
                      <FeatherIcon
                        style={{ width: "18px" }}
                        icon="chevron-left"
                        className="fs-14"
                        role="img"
                      />
                    )}
                  </button>
                  <button
                    type="button"
                    title={t("Next News")}
                    style={{ height: "40px" }}
                    aria-pressed="false"
                    className="btn fs-14 btn-secondary d-flex justify-content-center align-item-center"
                    disabled={
                      isListNewsLoading ||
                      isConfirmLoading ||
                      !!newsDetail?.disabled_next
                    }
                    onClick={() => handleNextNews(newsDetail?.index)}
                  >
                    {isListNewsLoading &&
                      query?.type_page_no_param === "next" ? (
                      <span
                        style={{ transform: "translateY(3px)", width: "18px" }}
                      >
                        <Spinner size="sm"></Spinner>
                      </span>
                    ) : (
                      <FeatherIcon
                        style={{ width: "18px" }}
                        icon="chevron-right"
                        className="fs-14"
                        role="img"
                      />
                    )}
                  </button>
                </div>
                <button
                  className="btn btn-secondary fs-14 px-1 d-flex justify-content-center align-item-center btn-width-close-news"
                  type="button"
                  color="light"
                  onClick={onCloseClick}
                  disabled={isConfirmLoading}
                >
                  <i className="ri-close-fill" style={{ lineHeight: "22px" }} />{" "}
                  <span className="ms-1">{t("Button Close")}</span>
                </button>
              </div>
            </div>
          </ModalFooter>
        </Modal>

        <ModalConfirm
          classButtonConfirm={typeActionConfirm?.type === "CANCEL" ? "btn-danger" : "btn-success"}
          header={typeActionConfirm?.type === "CANCEL" ? t('Button Cancel') : t('Button Run')}
          textButtonConfirm={typeActionConfirm?.type === 'CANCEL' ? t('Button Cancel') : t('Button Run')}
          title={typeActionConfirm?.type === 'CANCEL' ? t("Are you sure you want to cancel?") : t("Are you sure you want to run?")}
          content={typeActionConfirm?.type === 'CANCEL' ? t("After confirming the cancel action, the data will be permanently cancel and cannot be recovered. Do you want to proceed with the cancel action.") : t("After confirming the run action, the data will be permanently run and cannot be recovered. Do you want to proceed with the run action.")}
          isOpen={!!isOpenConfirm}
          classIconButtonConfirm={''}
          isLoading={isConfirmLoading}
          isShowIcon={false}
          onClose={onCloseConfirmClick}
          onConfirm={handleActionConfirm}
        />

        <ModalPostArticle isOpen={isOpenPostArticle} onCloseClick={onClickClosePostArticle} onReloadListNews={handleReloadListNews} />

      </div>
    </React.Fragment >
  );
};

export default PostList;
